<template>
  <article class="battle-queue">
    <h1 v-if="!compact && showTitle">
      <slot name="heading">{{
        $t('adaptive-test-battle.battle-queue-heading')
      }}</slot>
    </h1>

    <ul
      class="people-in-queue"
      :class="{ compact: compact }"
      v-if="peopleInQueue.length > 0"
      :style="{
        '--grid-cells': displayedGridCells,
      }"
    >
      <li
        class="person-in-queue"
        v-for="(person, index) in peopleInQueue"
        :key="index"
      >
        <PublicUserName
          :emoji="getEmoji(person)"
          :first-word-data="person['word_one']"
          :second-word-data="person['word_two']"
          :type="getColor(person)"
          :layout="compact ? 'compact' : 'stacked'"
          :glow="person['my_own']"
        />
      </li>
    </ul>
    <p class="empty-queue" v-else>
      {{ $t('adaptive-test-battle.battle-queue-is-empty') }}
    </p>
  </article>
</template>

<script>
import PublicUserName from '../username-display/PublicUserName'

export default {
  name: 'BattleQueue',
  components: { PublicUserName },
  props: {
    peopleInQueue: {
      type: Array,
      default: () => {
        return []
      },
    },
    gridCells: Number,
    compact: Boolean,
    showTitle: { type: Boolean, default: true },
  },
  data() {
    return {
      defaultGridCells: 5,
    }
  },
  computed: {
    displayedGridCells() {
      return this.compact
        ? this.peopleInQueue.length
        : Math.min(this.peopleInQueue.length, this.maxGridCellsAllowed)
    },
    maxGridCellsAllowed() {
      return this.gridCells < this.defaultGridCells
        ? this.gridCells
        : this.defaultGridCells
    },
  },
  methods: {
    getEmoji(person) {
      return person['emoji']['value']
    },
    getColor(person) {
      return person['color']['name']
    },
  },
}
</script>

<style lang="scss" scoped>
.battle-queue {
  display: flex;
  flex-flow: column;
}

h1,
p {
  padding: 0 0.5em;
}

h1 {
  @media (max-width: $minWidthTablet) {
    font-size: 2em;
  }
}

.people-in-queue {
  --grid-cells: 1;

  box-sizing: border-box;
  display: inline-grid;
  font-size: 0.875em;
  margin: auto;
  grid-template-columns: repeat(auto-fit, minmax(15%, 1fr));
  grid-gap: 1vw;

  &.compact {
    grid-template-columns: repeat(var(--grid-cells), minmax(min-content, auto));
  }

  &:not(.compact) {
    width: 80%;
    max-width: 65em;
    padding: 0.5em 4vw;
    border: 0.5em solid $indigo;
    border-radius: 0.5em;
    background: $violet;

    @media (max-width: $minWidthTablet) {
      width: 100%;
      max-width: 100%;
      border-radius: 0;
      border-left-width: 0;
      border-right-width: 0;
    }

    ::v-deep .public-user-name {
      .emoji {
        --emoji-border-color: #{$indigo};
      }

      .text-wrapper {
        width: 100%;
        max-width: 15em;
      }
    }
  }

  @media (max-width: $minWidthTablet) {
    font-size: 0.75em;
  }

  @media (max-width: $minWidthSmallTablet) {
    font-size: 0.5em;
    padding-top: 1em;
  }
}

.person-in-queue {
  padding-left: 0;
  background-image: none;
}

.empty-queue {
  font-size: 2em;
}

::v-deep .public-user-name {
  font-size: 1.5em;
  margin-top: 0.6em;

  .emoji {
    font-size: 2em;
  }
}
</style>
